/**
 * Vue rem插件
 * 提供全局rem转换功能
 */

const RemPlugin = {
  install: (app) => {
    // 在Vue实例上添加$px2rem方法
    app.config.globalProperties.$px2rem = (px) => {
      const BASE_FONT_SIZE = 16;
      return (px / BASE_FONT_SIZE) + 'rem';
    };
    
    // 也可以添加一个更通用的方法
    app.config.globalProperties.$rem = (px) => {
      const BASE_FONT_SIZE = 16;
      return (px / BASE_FONT_SIZE) + 'rem';
    };
  }
};

export default RemPlugin;